//Do not import anything
export const UI_VERSION = 'fed-mod-prod';
export const DIRECT_DOMAIN = "__DIRECT_DOMAIN__FALSE__".length !== 24;